import { cn } from '~/utils/cn';

import { DIFF_STATUS_BACKGROUND_CLASS, type DiffStatus } from './diff-status.util';

interface HighlightCardListProps {
  items: string[];
  /** Tints each card to match the field's diff status; `'unchanged'` (e.g. the Before row) falls back to a neutral card. */
  status: DiffStatus;
  /** Compact spacing and type for dense grids (the compare grid), where card-sized padding wastes most of a narrow column. */
  dense?: boolean;
  /** Automation hook: list id; each card gets `${testId}-item-{index}`. */
  testId?: string;
}

/** Renders a string-array field (e.g. Highlights) as individual rounded card rows instead of a bullet list, tinted by diff status. */
export function HighlightCardList({
  items,
  status,
  dense = false,
  testId = 'highlight-card-list',
}: HighlightCardListProps) {
  const bgClass = DIFF_STATUS_BACKGROUND_CLASS[status] || 'bg-muted';
  return (
    <div className={cn('flex flex-col', dense ? 'gap-1' : 'gap-2')} data-testid={testId}>
      {items.map((item, i) => (
        <div
          key={i}
          data-testid={`${testId}-item-${String(i)}`}
          className={cn(
            'text-foreground rounded-sm font-medium',
            dense ? 'px-1.5 py-1 text-xs leading-4' : 'px-4 py-3 text-sm',
            bgClass,
          )}
        >
          {item}
        </div>
      ))}
    </div>
  );
}
